<template>
  <div class='serviceTodo'>
    <div class="todoListContainer">
      <v-table
          ref="tableOverview"
          :row-click-color="'rgba(239,239,239,0.5)'"
          :row-click="overviewSelectRow"
          style="width:100%"
          :is-horizontal-resize="true"
          :columns="columns"
          :table-data="todoList"
          :show-vertical-border="false"
      ></v-table>
      <div class="pagination">
        <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange"
                      :total="todoPageCount"
                      :pageIndex="todoPageNumber" :page-size="todoPageSize"
                      :pageSizeOption="[5,10,15]"></v-pagination>
      </div>
    </div>
    <div v-if="processinstid" class="detailContainer">
      <service-todo-detail></service-todo-detail>
    </div>

  </div>
</template>

<script>
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex'
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //通信总线
  import Bus from 'common/js/bus.js'
  //服务事项详情
  import serviceTodoDetail from 'components/service/serviceTodoDetail'

  export default {
    name: "serviceTodo",
    data() {
      return {
        processinstid: null,
        columns: [
          {
            field: 'workItemID',
            title: '序号',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          },
          {
            field: 'title',
            title: '标题',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          },
          {
            field: 'orgname',
            title: '发起部门',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          },
          {
            field: 'username',
            title: '申请人',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          },
          // {
          //   field: 'updatetime',
          //   title: '上次处理时间',
          //   width: 100,
          //   titleAlign: 'center',
          //   columnAlign: 'center',
          //   isResize: true,
          // },

          {
            field: 'applytime',
            title: '创建时间',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          },
          {
            field: 'state',
            title: '完成状态',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          }
        ],

        todoList: [],

        todoPageNumber: 1,
        todoPageSize: 10,
        todoPageCount: null,

      }
    },
    props: ['serviceInfo'],
    computed: {},
    watch: {},
    methods: {
      //获取事项列表
      async _initTodoList() {
        let sysName = this.serviceInfo.name

        let todoList = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getWorkList?' + this.$qs.stringify({
          endtime: null,
          pageNumber: this.todoPageNumber,
          pageSize: this.todoPageSize,
          starttime: null,
          sysname: sysName,
          title: null,
          type: -1,
          username: null
        }))
        if (!todoList.data.status) {
          return
        }
        let todoListObj = todoList.data.data[0]
        this.todoPageNumber = todoListObj.pageNumber
        this.todoPageCount = todoListObj.pageCount
        this.todoList = todoListObj.list
      },
      overviewSelectRow(rowIndex, rowData, column) {
        this.processinstid = rowData.id
      },
      pageChange(pageIndex) {
        this.todoPageNumber = pageIndex
        this._initTodoList()
      },
      pageSizeChange(pageSize) {
        this.todoPageSize = pageSize
        this._initTodoList()
      },
    },
    filters: {},
    components: {serviceTodoDetail},
    activated() {
    },
    mounted() {
      this._initTodoList()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../common/stylus/config.styl"
  .serviceTodo
    setPositionFull()

    .todoListContainer
      & >>> .v-table-row
        cursor pointer

        &:hover
          background-color #f1f1f1
</style>



// WEBPACK FOOTER //
// src/components/service/serviceTodo.vue